import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { EnvironmentConfigInterface, PE_ENV } from '@pe/common/core';

import { ProductInterface } from '../types';

@Injectable({
  providedIn: 'root',
})
export class ProductsApiService {

  private readonly http: HttpClient = this.injector.get(HttpClient);
  private readonly env: EnvironmentConfigInterface = this.injector.get(PE_ENV);

  constructor(
    private readonly injector: Injector
  ) {
  }

  getProducts(includeIds: string[], businessUuid: string): Observable<ProductInterface[]> {
    return this.http.get<{ products: ProductInterface[] }>(
      `${this.env.backend.products}/products`,
      { params: new HttpParams().appendAll({ includeIds, businessUuid }) },
    ).pipe(map(({ products }) => products));
  }
}
